import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dkn-admin-statuses mt-2" }
const _hoisted_2 = { class: "dkn-admin-status-header" }
const _hoisted_3 = { class: "dkn-admin-status-value" }
const _hoisted_4 = {
  key: 0,
  class: "dkn-mps-section"
}
const _hoisted_5 = { class: "dkn-mps-section-title" }
const _hoisted_6 = { class: "asset-stats-grid" }
const _hoisted_7 = { class: "dkn-admin-status-header" }
const _hoisted_8 = { class: "dkn-admin-status-value" }
const _hoisted_9 = {
  key: 1,
  class: "dkn-mps-section"
}
const _hoisted_10 = { class: "dkn-mps-section-title" }
const _hoisted_11 = { class: "asset-stats-grid" }
const _hoisted_12 = { class: "dkn-admin-status-header" }
const _hoisted_13 = { class: "dkn-admin-status-value" }
const _hoisted_14 = {
  key: 2,
  class: "dkn-mps-section"
}
const _hoisted_15 = { class: "dkn-mps-section-title" }
const _hoisted_16 = { class: "asset-stats-grid" }
const _hoisted_17 = { class: "dkn-admin-status-header" }
const _hoisted_18 = { class: "dkn-admin-status-value" }
const _hoisted_19 = {
  key: 3,
  class: "dkn-mps-section"
}
const _hoisted_20 = { class: "dkn-mps-section-title" }
const _hoisted_21 = { class: "asset-stats-grid" }
const _hoisted_22 = { class: "dkn-admin-status-header" }
const _hoisted_23 = { class: "dkn-admin-status-value" }
const _hoisted_24 = {
  key: 4,
  class: "dkn-mps-section"
}
const _hoisted_25 = { class: "dkn-mps-section-title" }
const _hoisted_26 = { class: "asset-stats-grid" }
const _hoisted_27 = { class: "dkn-admin-status-header" }
const _hoisted_28 = { class: "dkn-admin-status-value" }
const _hoisted_29 = {
  key: 5,
  class: "dkn-mps-section"
}
const _hoisted_30 = { class: "dkn-mps-section-title" }
const _hoisted_31 = { class: "asset-stats-grid" }
const _hoisted_32 = { class: "dkn-admin-status-header" }
const _hoisted_33 = { class: "dkn-admin-status-value" }
const _hoisted_34 = {
  key: 1,
  class: "modbus-empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.hasAnyParam)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quickStatuses, (status) => {
            return (_openBlock(), _createElementBlock("div", {
              key: status.key,
              class: _normalizeClass(["dkn-admin-status", status.toneClass])
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("i", {
                  class: _normalizeClass(status.icon)
                }, null, 2),
                _createElementVNode("span", null, _toDisplayString(status.label), 1)
              ]),
              _createElementVNode("div", _hoisted_3, _toDisplayString(status.value), 1)
            ], 2))
          }), 128))
        ]),
        (_ctx.d10DiagnosticsItems.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[0] || (_cache[0] = _createElementVNode("i", { class: "bi bi-exclamation-triangle" }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assetDetails.dknUartGroupTitles.diagnostics')), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.d10DiagnosticsItems, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.key,
                    class: _normalizeClass(["dkn-admin-status dkn-param-card", item.toneClass])
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _cache[1] || (_cache[1] = _createElementVNode("i", { class: "bi bi-clipboard-data" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(item.label), 1)
                    ]),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(item.value), 1)
                  ], 2))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.tempPressureItems.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _cache[2] || (_cache[2] = _createElementVNode("i", { class: "bi bi-thermometer-sun" }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assetDetails.dknUartGroupTitles.tempsAndPressures')), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tempPressureItems, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.key,
                    class: _normalizeClass(["dkn-admin-status dkn-param-card", item.toneClass])
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      _cache[3] || (_cache[3] = _createElementVNode("i", { class: "bi bi-thermometer-half" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(item.label), 1)
                    ]),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(item.value), 1)
                  ], 2))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.compressorFansValveItems.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _cache[4] || (_cache[4] = _createElementVNode("i", { class: "bi bi-gear-wide-connected" }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assetDetails.dknUartGroupTitles.compressorFansValves')), 1)
              ]),
              _createElementVNode("div", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.compressorFansValveItems, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.key,
                    class: _normalizeClass(["dkn-admin-status dkn-param-card", item.toneClass])
                  }, [
                    _createElementVNode("div", _hoisted_17, [
                      _cache[5] || (_cache[5] = _createElementVNode("i", { class: "bi bi-gear" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(item.label), 1)
                    ]),
                    _createElementVNode("div", _hoisted_18, _toDisplayString(item.value), 1)
                  ], 2))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.d10FlagsItems.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _cache[6] || (_cache[6] = _createElementVNode("i", { class: "bi bi-toggle-on" }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assetDetails.dknUartGroupTitles.d10Flags')), 1)
              ]),
              _createElementVNode("div", _hoisted_21, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.d10FlagsItems, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.key,
                    class: _normalizeClass(["dkn-admin-status dkn-param-card", item.toneClass])
                  }, [
                    _createElementVNode("div", _hoisted_22, [
                      _cache[7] || (_cache[7] = _createElementVNode("i", { class: "bi bi-toggles" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(item.label), 1)
                    ]),
                    _createElementVNode("div", _hoisted_23, _toDisplayString(item.value), 1)
                  ], 2))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.d10ProtectionItems.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _cache[8] || (_cache[8] = _createElementVNode("i", { class: "bi bi-shield-check" }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assetDetails.dknUartGroupTitles.d10Protection')), 1)
              ]),
              _createElementVNode("div", _hoisted_26, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.d10ProtectionItems, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.key,
                    class: _normalizeClass(["dkn-admin-status dkn-param-card", item.toneClass])
                  }, [
                    _createElementVNode("div", _hoisted_27, [
                      _cache[9] || (_cache[9] = _createElementVNode("i", { class: "bi bi-shield" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(item.label), 1)
                    ]),
                    _createElementVNode("div", _hoisted_28, _toDisplayString(item.value), 1)
                  ], 2))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.d00ConfigItems.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _cache[10] || (_cache[10] = _createElementVNode("i", { class: "bi bi-info-circle" }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assetDetails.dknUartGroupTitles.d00Config')), 1)
              ]),
              _createElementVNode("div", _hoisted_31, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.d00ConfigItems, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.key,
                    class: _normalizeClass(["dkn-admin-status dkn-param-card", item.toneClass])
                  }, [
                    _createElementVNode("div", _hoisted_32, [
                      _cache[11] || (_cache[11] = _createElementVNode("i", { class: "bi bi-hash" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(item.label), 1)
                    ]),
                    _createElementVNode("div", _hoisted_33, _toDisplayString(item.value), 1)
                  ], 2))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ], 64))
    : (_openBlock(), _createElementBlock("div", _hoisted_34, [
        _cache[12] || (_cache[12] = _createElementVNode("i", { class: "bi bi-wind" }, null, -1)),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assetDetails.dknUartMessages.noData')), 1)
      ]))
}